/* __next_internal_client_entry_do_not_use__ useAppNudgeStore,AppNudgeProvider auto */ import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";
/**
 * We can create a Context Store with the UI state that
 * we need to keep track of.
 */ var _createContextStore = createContextStore({
    isAbandonedCartNudgeShown: true,
    hasAcknowledgedAbandonedCartNudge: false,
    isOpenWithFaireNudgeShown: true,
    hasAcknowledgedOpenWithFaireNudge: false,
    hasAcknowledgedPopupOptInNudge: false,
    isKnownReferrerNudgeShown: true,
    hasAcknowledgedKnownReferrerNudge: false,
    isReengageReferralNudgeShown: true,
    hasAcknowledgedReengageReferralNudge: false,
    hasAcknowledgedReferralAdoptionNudge: false,
    isReferralAdoptionNudgeShown: true
}, {
    name: "AppNudgeStore"
}), useAppNudgeStore = _createContextStore.useStore, AppNudgeProvider = _createContextStore.Provider;
export { useAppNudgeStore, AppNudgeProvider };
